import { Howl } from 'howler';
// --- external imports -----

class Sound {
	constructor(src, maximumVolume = 1, shouldLoop = false, fadeTime = 0) {
		this.maximumVolume = maximumVolume;
		this.fadeTime = fadeTime;

		this.isSoundPlaying = false;
		this.shouldFade = fadeTime > 0;
		this.shouldLoop = shouldLoop;

		const volume = this.shouldFade
			? 0
			: maximumVolume;
		
		this.soundInstance = new Howl({
			src,
			volume,
			loop: shouldLoop
		});
	}

	play() {
		if (this.shouldLoop) {
			if (this.isSoundPlaying) {
				return;
			}

			this.isSoundPlaying = true;
		}

		if (this.shouldFade) {
			this.soundInstance.fade(
				0,
				this.maximumVolume,
				this.fadeTime,
				this._getSoundPlayId
			);
		}
		else {
			this.soundInstance.play();
		}
	}

	pause() {
		if (this.shouldLoop) {
			if (!this.isSoundPlaying) {
				return;
			}

			if (this.shouldFade) {
				this.soundInstance.fade(
					this.maximumVolume, 
					0,
					this.fadeTime,
					this._getSoundPlayId
				);
			}
			else {
				this.soundInstance.pause();
			}

			this.isSoundPlaying = false;
		}
		else {
			this.soundInstance.pause();
		}
	}

	get _getSoundPlayId() {
		if(!this.soundPlayId) {
			this.soundPlayId = this.soundInstance.play();
		}

		return this.soundPlayId;
	}
}

export default Sound;
